import * as React from 'react'

const SvgBlockedAreaInactive = props => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="9" stroke="#00293B" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M9.63634 22.3637L22.3643 9.63574" stroke="#00293B" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
)

export default SvgBlockedAreaInactive